// extracted by mini-css-extract-plugin
export default {"root":"register-card_root__ALutA","title":"register-card_title__WVIlA","image":"register-card_image__Jtfi5","actions":"register-card_actions__Dj18m"};